import { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

import SettingsLayout from './_layout';

const GeneralSettingsPage = lazy(() => import('./general'));
const NotificationsSettingsPage = lazy(() => import('./notifications'));
const PreferencesSettingsPage = lazy(() => import('./preferences'));
const PrivacySettingsPage = lazy(() => import('./privacy'));

export const settingsRoutes: RouteObject[] = [
  {
    element: <SettingsLayout />,
    children: [
      {
        path: '/profile/settings/general',
        element: <GeneralSettingsPage />,
        handle: { breadcrumb: 'Settings' },
      },
      {
        path: '/profile/settings/notifications',
        element: <NotificationsSettingsPage />,
        handle: { breadcrumb: 'Notifications' },
      },
      {
        path: '/profile/settings/privacy',
        element: <PrivacySettingsPage />,
        handle: { breadcrumb: 'Privacy' },
      },
      {
        path: '/profile/settings/preferences',
        element: <PreferencesSettingsPage />,
        handle: { breadcrumb: 'Preferences' },
      },
    ],
  },
];
